import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../constants/routes";
import { LOGOUT } from "../../constants/actionTypes";
import { useEffect } from "react";

const LogoutScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  dispatch({
    type: LOGOUT,
  });

  useEffect(() => {
    navigate(LOGIN);
  }, []);

  return <></>;
};

export default LogoutScreen;
